



















































































































import useChatInput from "@/composables/v3/useChatInput";
//@ts-ignore
import useVerticalLayout from "@core/layouts/layout-vertical/useVerticalLayout";
import { mobilePluginBarActive } from "@/composables/v3/useUx";
import useUserSettings from "@/composables/useUserSettings";
import { useChatsStore } from "@/store/useChatsStore";
import { useContactsStore } from "@/store/useContactsStore";
import { useTagsStore } from "@/store/useTagsStore";
import Apps from "@/views/modules/messaging-inbox/sidebar-right/apps.vue";
import Contact from "@/views/modules/messaging-inbox/sidebar-right/contact.vue";
import InternalComments from "@/views/modules/messaging-inbox/sidebar-right/internalComments.vue";
import Tags from "@/views/modules/messaging-inbox/sidebar-right/tags.vue";
import { computed, defineComponent, Ref, ref, watch } from "@vue/composition-api";
import { BAvatar, BButton, VBTooltip } from "bootstrap-vue";
import { useApps } from "@/composables/useApps";
import { getUserData } from "@/auth/getUserData";
// @ts-ignore
import useVerticalNavMenu from "@core/layouts/layout-vertical/components/vertical-nav-menu/useVerticalNavMenu";

export default defineComponent({
    components: { BButton, InternalComments, Contact, Tags, Apps, BAvatar },
    directives: {
        "b-tooltip": VBTooltip,
    },
    setup() {
        const { updateVerticalMenuCollapsed } = useVerticalLayout();
        const { isRightMenuCollapsed } = useVerticalNavMenu();
        const { getUserSetting } = useUserSettings();

        const chatsStore = useChatsStore();
        const tagsStore = useTagsStore();
        const contactsStore = useContactsStore();

        watch(
            () => chatsStore.activeChat,
            () => {
                if (!chatsStore.activeChat) {
                    return;
                }

                tagsStore.fetchChatTags(chatsStore.activeChat.chat.id);
            }
        );

        //----------------------------------------------------------------------
        const collapseBtnIsVisible = ref(false);
        const activeSidebarView = ref();
        const activeAppId: Ref<number | undefined> = ref<number | undefined>();

        watch(isRightMenuCollapsed, () => {
            const userRecentSelection = JSON.parse(localStorage.getItem("rightSideMenuSelection"));
            activeSidebarView.value = userRecentSelection?.section || "sidebar-contact";
            activeAppId.value = userRecentSelection?.appId;
        });

        const toggleActive = (id: string, appId?: number) => {
            // Remove all tooltips because they can get stuck in the way
            // @conversations-layer disabled.
            // setTimeout(() => {
            //     root.$emit("bv::hide::tooltip");
            // }, 250);

            // If we clicked the same app that is already open, we collapse
            // Sidebar-apps also need to match the4 activeAppId
            if (
                (id === "sidebar-apps" && activeSidebarView.value === id && appId === activeAppId.value) ||
                (activeSidebarView.value === id && id !== "sidebar-apps")
            ) {
                closeSidebarViews();
                return;
            }

            if (id === "sidebar-contact") {
                collapseBtnIsVisible.value = false;
            }

            if (!collapseBtnIsVisible.value && id != "sidebar-contact") {
                setTimeout(() => {
                    collapseBtnIsVisible.value = true;
                }, 500);
            }

            activeSidebarView.value = id;
            activeAppId.value = appId;

            isRightMenuCollapsed.value = true;
            updateVerticalMenuCollapsed(true);
            localStorage.setItem("rightSideMenuSelection", JSON.stringify({ section: id, appId }));
        };

        const initStateFromUserData = (userData) => {
            const userRecentSelection = JSON.parse(localStorage.getItem("rightSideMenuSelection"));
            const rightSideMenuIsOpen = Boolean(Number(getUserSetting("rightSideMenuIsOpen")));
            toggleActive(userRecentSelection?.section || "sidebar-contact", userRecentSelection?.appId);
            isRightMenuCollapsed.value = rightSideMenuIsOpen;
            updateVerticalMenuCollapsed(rightSideMenuIsOpen);
        };
        initStateFromUserData(getUserData());

        const closeSidebarViews = () => {
            isRightMenuCollapsed.value = false;
            updateVerticalMenuCollapsed(false);
            // Close the active app AFTER the animation (0.4s) is done
            setTimeout(() => {
                activeSidebarView.value = undefined;
            }, 500);
        };

        const { apps, loadApps } = useApps();
        loadApps();

        // Make to perfect scrollbar scrollable from within apps via app.utils
        const sidebarContentScrollbar = ref();
        const scrollToTop = () => {
            const scrollEl = sidebarContentScrollbar.value.$el || sidebarContentScrollbar.value;
            scrollEl.scrollTop = 0;
        };

        const { message } = useChatInput();
        return {
            message,
            activeAppId,
            activeApps: computed(() =>
                apps.value.filter((app) => app.package && app.settings?.active === true && app.name != "Zapier")
            ),
            activeSidebarView,
            chatsStore,
            closeSidebarViews,
            collapseBtnIsVisible,
            contactsStore,
            isRightMenuCollapsed,
            tagsStore,
            toggleActive,
            scrollToTop,
            mobilePluginBarActive,
        };
    },
});
